import { Theme, Languages } from 'types';
import configEnv, { ConfigEnvI } from './config-env';
import getCurrentLang from '../utils/translation/getCurrentLang';
import maintenance, { MaintenanceT } from './maintenance/maintenance';

export interface Config {
  configEnv: ConfigEnvI;
  theme: Theme;
  currentLanguage: Languages;
  maintenance: MaintenanceT;
  countryBlacklist: boolean;
}

const config: Config = {
  configEnv,
  theme: (localStorage.getItem(Theme.LocalStorageThemeItem) as Theme) || Theme.Light,
  currentLanguage: getCurrentLang(),
  maintenance,
  countryBlacklist: false,
};

export default config;
